module.exports = __webpack_public_path__ + "static/green_flash_bk-d9efd59a2822dc1ceb3d468f98d8bf89.png";